/**
 * Errores de la API.
 *
 * Nada de esto se enseña crudo al usuario. `ErrorApi` lleva el dato técnico;
 * la traducción a "qué pasó, por qué y qué hacer" vive en el dominio
 * (`dominio/documentos/errores.ts`) y el componente solo presenta el resultado.
 */

export type ClaseDeError =
  | 'red' // el navegador no llegó al servidor
  | 'autenticacion' // 401
  | 'permiso' // 403
  | 'no-encontrado' // 404
  | 'validacion' // 422
  | 'conflicto' // 409 — idempotencia repetida con otro cuerpo
  | 'servidor' // 5xx
  | 'desconocido'

export class ErrorApi extends Error {
  readonly clase: ClaseDeError
  readonly estado: number
  /** Código del servicio o de DGII. Queda accesible, plegado, para soporte. */
  readonly codigo: string | undefined
  /** Cuerpo crudo de la respuesta. Nunca se muestra sin traducir. */
  readonly crudo: string | undefined

  constructor(opciones: {
    mensaje: string
    clase: ClaseDeError
    estado: number
    codigo?: string
    crudo?: string
  }) {
    super(opciones.mensaje)
    this.name = 'ErrorApi'
    this.clase = opciones.clase
    this.estado = opciones.estado
    this.codigo = opciones.codigo
    this.crudo = opciones.crudo
  }

  /** Solo se reintenta lo que puede cambiar de resultado al repetirlo. */
  get esReintentable(): boolean {
    return this.clase === 'red' || this.clase === 'servidor'
  }
}

export function claseSegunEstado(estado: number): ClaseDeError {
  if (estado === 401) return 'autenticacion'
  if (estado === 403) return 'permiso'
  if (estado === 404) return 'no-encontrado'
  if (estado === 409) return 'conflicto'
  if (estado === 422 || estado === 400) return 'validacion'
  if (estado >= 500) return 'servidor'
  return 'desconocido'
}
